import React, { useEffect, useRef, useState } from "react";
import ddd from "../../../assets/image/image.png";
import { Link } from "react-router-dom";

const StatsSection = () => {
    const sectionRef = useRef(null);
    const [start, setStart] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setStart(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.4 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    const counters = [
        { end: 1000, suffix: "+", label: " Clients Served" },
        // { end: 95, suffix: "%", label: "Overall Visa Success Rate" },
        // { end: 42, suffix: "hrs", label: "Application Approval Time" },
    ];

    return (
        <section
            ref={sectionRef}
            className="relative bg-gradient-to-t from-white from-40% to-[#f3f6f9] to-0%"
        >
            <div className="max-w-7xl mx-auto px-4 pt-8 md:pt-16">

                {/* TOP IMAGE + RED PANEL */}
                <div className="flex flex-col lg:flex-row overflow-hidden shadow-lg">

                    {/* IMAGE */}
                    <div className="h-64 md:h-[320px] w-full lg:w-[350px] flex-shrink-0">
                        <img
                            src={ddd}
                            alt="Visa"
                            className="w-full h-full object-cover  md:rounded-tr-none"
                        />
                    </div>

                    {/* RED PANEL */}
                    <div className="bg-[#ec4e4f] text-white p-6 md:p-10 flex flex-col justify-center over-flow-hidden  md:rounded-bl-none relative">
                        <h4 className="text-[20px] mb-3 opacity-1 text-center md:text-left">
                            Free Online Immegration Assessment

                        </h4>
                        <h2 className="text-2xl md:text-[36px] font-bold mb-6 leading-tight text-center md:text-left">
                            Top rated by clients and immigration partners for reliability and service quality.

                        </h2>
                        <div className="flex justify-center md:justify-start">
                            <Link to="/contact-us" className="border-2 relative z-[999] border-white px-6 py-3 font-[600] hover:bg-white text-[18px] hover:text-[#ec4e4f] transition">
                                → Apply Now
                            </Link>
                        </div>




                        <div className="absolute left-[-70px] bottom-[-75px] 
                w-[255px] h-[255px] 
                rounded-full 
                bg-white/10">
                        </div>
                        <div className="absolute top-[-70px] right-[-190px] 
                w-[255px] h-[255px] 
                rounded-full 
                bg-white/10">
                        </div>
                    </div>
                </div>

                {/* COUNTERS */}
                <div className="grid grid-cols-1 md:grid-cols-1 bg-white border border-[#e0e6ed] overflow-hidden border-r-0">
                    {counters.map((item, i) => (
                        <CounterBox key={i} {...item} start={start} isLast={i === counters.length - 1} />
                    ))}
                </div>

            </div>
        </section>
    );
};

const CounterBox = ({ end, suffix = "", label, start, isLast }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!start) return;

        let current = 0;
        const increment = end / 120;

        const timer = setInterval(() => {
            current += increment;
            if (current >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(Math.floor(current));
            }
        }, 16);

        return () => clearInterval(timer);
    }, [start, end]);

    return (
        <div className={`text-center p-6 md:p-12 border-b md:border-b-0 md:border-r border-[#e0e6ed] ${isLast ? "border-r-0" : ""}`}>
            <h2 className="text-4xl md:text-5xl font-[400] text-[#2d5883]">
                {count.toLocaleString()}
                {suffix}
            </h2>
            <p className="mt-3 text-[#222222] cabin  font-[400]  text-lg md:text-[32px] leading-snug">
                {label}
            </p>
        </div>
    );
};

export default StatsSection;
